module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray@2x-5d66e6fa1430ddc382963a1943f9cabd.png";